import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Input, ChangeDetectorRef, OnChanges, SimpleChanges
} from '@angular/core';

interface IMacros {
    title: string;
    image: string;
    minValue: number;
    maxValue: number;
    percentage: string;
    backgroundColor: string;
}

@Component({
    selector: 'app-macros-bar',
    templateUrl: './macros-bar.component.html',
    styleUrls: ['./macros-bar.component.scss']
})
export class MacrosBarComponent {
    @Input() diaryMacros = {
        calories: 0,
        carbs: 0,
        fat: 0,
        protein: 0
    };
    @Input() userCalculations = {
        calories: 0,
        carbs: 0,
        fat: 0,
        protein: 0
    };
    @Input() includeWater = false;

    round(number: number): number {
        return Math.round(number);
    }

    percentage(number1: number, dividedByNumber2: number): string {
        if (!dividedByNumber2 || dividedByNumber2 <= 0) {
            return '0%';
        }

        let percentage = Math.round((number1 / dividedByNumber2) * 100);

        if (percentage > 100) {
            percentage = 100;
        }

        return percentage + '%';
    }

}
